import type { TOC } from '@ember/component/template-only';
import {
  PrismButton,
  PrismCard,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import type HotelSettingsMyotbPmsUnsupportedController from 'lumen/controllers/hotel/settings/myotb/pms-unsupported';

interface HotelSettingsMyotbPmsUnsupportedSignature {
  Args: {
    controller: HotelSettingsMyotbPmsUnsupportedController;
    model: unknown;
  };
}

<template>
  {{#if @controller.myotbSs.canUserEditOtb}}
    <PrismCard
      @contentLayout="noPadding"
      class="myotb-card flex items-center justify-center"
    >
      <:content>
        <PrismMessage
          @description={{t
            "settings.my_otb.pms_unsupported.body.with_research"
          }}
          @illustration="100x100_warning"
          @title={{t "settings.my_otb.pms_unsupported.title"}}
        >
          <:secondaryAction>
            <PrismButton
              @buttonType="secondary"
              @isDisabled={{or
                @controller.withdrawFromResearchTask.isRunning
                @controller.signUpForResearchTask.isRunning
              }}
              @isLoading={{@controller.withdrawFromResearchTask.isRunning}}
              @label={{t "settings.my_otb.pms_unsupported.cta.no"}}
              @onClick={{@controller.withdrawFromResearchTask.perform}}
            />
          </:secondaryAction>
          <:primaryAction>
            <PrismButton
              @isDisabled={{or
                @controller.withdrawFromResearchTask.isRunning
                @controller.signUpForResearchTask.isRunning
              }}
              @isLoading={{@controller.signUpForResearchTask.isRunning}}
              @label={{t "settings.my_otb.pms_unsupported.cta.yes"}}
              @onClick={{@controller.signUpForResearchTask.perform}}
            />
          </:primaryAction>
        </PrismMessage>
      </:content>
    </PrismCard>
  {{else}}
    <PrismCard
      @contentLayout="noPadding"
      class="myotb-card flex items-center justify-center"
    >
      <:content>
        <PrismMessage
          @description={{t
            "settings.my_otb.pms_unsupported.body.without_research"
          }}
          @illustration="100x100_warning"
          @title={{t "settings.my_otb.pms_unsupported.title"}}
        />
      </:content>
    </PrismCard>
  {{/if}}
</template> satisfies TOC<HotelSettingsMyotbPmsUnsupportedSignature>;
